import type { As } from '@chakra-ui/react';
import { Box, Button, Circle, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import Skeleton from 'ui/shared/chakra/Skeleton';
import IconSvg from 'ui/shared/IconSvg';

const FilterIcon = <IconSvg name="filter" boxSize={ 5 } mr={{ base: 0, lg: 2 }}/>;

interface Props {
  isActive?: boolean;
  isLoading?: boolean;
  appliedFiltersNum?: number;
  onClick: () => void;
  as?: As;
  variant?: string;
}

const FilterButton = ({ isActive, isLoading, appliedFiltersNum, onClick, as, variant }: Props, ref: React.ForwardedRef<HTMLButtonElement>) => {
  const badgeColor = useColorModeValue('white', 'green.50');
  const badgeBgColor = useColorModeValue('green.500', 'gray.300');
  const btnBorderColor = useColorModeValue('#E9ECEF', '#363636');
  const btnBgColor = useColorModeValue('transparent', 'gray.500');
  const btnColor = useColorModeValue('#000000', undefined);

  if (isLoading) {
    return <Skeleton w={{ base: 9, lg: '78px' }} h={ 8 } borderRadius="base" flexShrink={ 0 }/>;
  }

  const num = (
    <Circle
      className="AppliedFiltersNum"
      bg={ isActive ? 'link_hovered' : badgeBgColor }
      size={ 5 }
      color={ badgeColor }
    >
      { appliedFiltersNum }
    </Circle>
  );

  return (
    <Button
      ref={ ref }
      rightIcon={ appliedFiltersNum ? num : undefined }
      size="sm"
      fontWeight="500"
      variant={ variant || 'outline' }
      colorScheme="gray"
      onClick={ onClick }
      isActive={ isActive }
      data-selected={ Boolean(appliedFiltersNum) }
      px={ 1.5 }
      flexShrink={ 0 }
      as={ as }
      pointerEvents="all"
      border="1px solid"
      borderColor={ btnBorderColor }
      bgColor={ btnBgColor }
      color={ btnColor }
      _hover={ isActive ? {
        color: 'link_hovered',
        '.AppliedFiltersNum': {
          bg: 'link_hovered',
        },
      } : undefined }
    >
      { FilterIcon }
      <Box display={{ base: 'none', lg: 'block' }}>Filter</Box>
    </Button>
  );
};

export default React.forwardRef(FilterButton);
